import { render, staticRenderFns } from "./WidgetListItem.vue?vue&type=template&id=5bc9a308&"
import script from "./WidgetListItem.vue?vue&type=script&lang=js&"
export * from "./WidgetListItem.vue?vue&type=script&lang=js&"
import style0 from "./WidgetListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports